import { css } from '@emotion/core'
import React, { type ReactNode } from 'react'

const preWrapLineCss = css`
  white-space: pre-wrap;
`

type Props = { children: ReactNode }

export default function PreWrapSpan({ children }: Props): JSX.Element {
  return <span css={preWrapLineCss}>{children}</span>
}
